import request from "@/utils/request";

// 查询流程定义列表
export function listModel(query) {
  return request({
    url: "/act/needDealt/list",
    method: "get",
    params: query,
  });
}

export function dealtTaskInfo(taskId) {
  return request({
    url: `/act/needDealt/getDealtTaskInfo/${taskId}`,
    method: "get",
  });
}

export function startFormInfo(instanceId) {
  return request({
    url: `/act/needDealt/getStartFormInfo/${instanceId}`,
    method: "get",
  });
}

export function historyFormData(taskId) {
  return request({
    url: `/act/needDealt/historyFormData/${taskId}`,
    method: "get",
  });
}

export function theLastTaskVariablesByCurrentTaskId(taskId) {
  return request({
    url: `/act/needDealt/getTheLastTaskVariablesByCurrentTaskId/${taskId}`,
    method: "get",
  });
}

export function highLine(instanceId) {
  return request({
    url: `/act/needDealt/getHighLine/${instanceId}`,
    method: "get",
  });
}

export function taskOperationLog(instanceId) {
  return request({
    url: `/act/needDealt/getTaskOperationLog/${instanceId}`,
    method: "get",
  });
}

export function completeTask(data) {
  return request({
    url: `/act/needDealt/completeTask`,
    method: "post",
    data: data,
  });
}

export function hisTaskForm(taskId) {
  return request({
    url: `/act/needDealt/getTaskHisForm/${taskId}`,
    method: "get",
  });
}

export function getBackNodes(instanceId) {
  return request({
    url: `/act/needDealt/getBackNodes/${instanceId}`,
    method: "get",
  });
}

export function getRelationProcess(instanceId, businessKey) {
  return request({
    url: `/act/needDealt/getRelationProcess?instanceId=${instanceId}&businessKey=${businessKey}`,
    method: "get",
  });
}
